<template>
  <div id="story_layout">
    <div
      v-if="storyRef && storyRef.data"
      id="story_container"
    >
      <StoryHeading
        :heading="storyRef.data.heading.heading"
        :content="storyRef.data.heading.content"
      />
      <StoryBanner
        :heading="storyRef.data.banner.heading"
        :heading2="storyRef.data.banner.heading_2"
        :content="storyRef.data.banner.content"
        :image1="storyRef.data.banner.image_1"
        :image2="storyRef.data.banner.image_2"
      />
      <StorySlide />
    </div>

    <div id="story_gallery">
      <StoryGallery />
    </div>
    <PageGtm />
    <PageTrackingGtm
      v-if="metaTitle"
      :page-title-gtm="metaTitle"
    />
  </div>
</template>

<script type="module">
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
// import LazyHydrate from 'vue-lazy-hydration';
import { contentGetters, useContent } from '@vue-storefront/gemini';
import { onSSR } from '@vue-storefront/core';
import { CacheTagPrefix, useCache } from '@gemini/vsf-cache';
import StoryHeading from '~/components/StoryHeading.vue';
import StoryBanner from '~/components/StoryTop.vue';
import StorySlide from '~/components/StorySlide.vue';
import StoryGallery from '~/components/StoryGallery.vue';
import PageGtm from '~/components/Gtm/PageGtm.vue';
import PageTrackingGtm from '~/components/Gtm/PageTrackingGtm.vue';
import { useI18n } from '../helpers/hooks/usei18n';

export default defineComponent({
  name: 'StoryList',
  components: {
    // LazyHydrate,
    StoryHeading,
    StoryBanner,
    StorySlide,
    StoryGallery,
    PageGtm,
    PageTrackingGtm,
  },
  setup() {
    const { locale } = useI18n();
    const { blocks } = useContent(`cmsBlockFooter-${locale}`);

    const { addTags } = useCache();

    onSSR(() => {
      addTags([
        { prefix: CacheTagPrefix.View, value: 'story' },
        { prefix: CacheTagPrefix.View, value: 'page' },
      ]);
    });

    const identifierStory = `StoryHeading-${locale}`;

    const storyRef = ref(false);

    const story = computed(() => contentGetters.getCmsBlockContent(blocks.value)).value[identifierStory];
    const metaTitle = locale === 'en' ? 'Lazzari, handmade with love in Italy' : 'Lazzari e il Made in Italy';
    const metaDescription = locale === 'en' ? 'We are a small family-run business with a strong bond with our country.' : 'Siamo una piccola azienda di famiglia con forti legami con il tessuto produttivo del nostro paese.';

    return {
      story,
      storyRef,
      identifierStory,
      metaTitle,
      metaDescription,
    };
  },
  head() {
    return {
      title: this.metaTitle,
      meta: [
        { hid: 'robots', name: 'robots', content: 'index, follow' },
        { hid: 'og:description', property: 'og:description', content: this.metaDescription },
        { hid: 'description', name: 'description', content: this.metaDescription },
        { hid: 'og:title', property: 'og:title', content: this.metaTitle },
      ],
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: 'https://cdn.lazzarionline.com/626a5446ce6aed36346c7a07.jpg', // @FIXME do not hardcode this!!!
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.storyRef = this.story;
    });
  },
});
</script>

<style lang="scss" scoped>
  #story_container {
    background-color: var(--_c-pink-primary);
    min-height: 500px;
  }
  #story_layout {
    min-height: 500px;
  }
</style>
